import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { HttpRequestService } from 'src/app/core/services';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { NzModalService } from 'ng-zorro-antd/modal';
import { SubscriptionModalComponent } from 'src/app/shared/components/subscription-modal/subscription-modal.component';
import { CommonArrayService } from 'src/app/core/services/common-array.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  allUsers: any[] = [];
  totalDataCount = 0;
  pageSize = 12;
  pageIndex = 1;
  loading = false;
  searchUser: Subject<any> = new Subject<any>();
  search = '';
  listView = true;
  active: boolean = false;
  deActive: boolean = true;
  dateRange: any;
  startDate: any;
  endDate: any;
  apiUrl = environment.apiBaseUrl;
  skipIndex: number = 0;
  selectedUserStatus: string = '';
  allUserStatus: any[] = [];
  subscriberOrNot: boolean = false;

  constructor(
    private route: Router,
    private drawerService: NzDrawerService,
    private httpRequestService: HttpRequestService,
    private notificationService: NzNotificationService,
    private modal: NzModalService,
    private viewContainerRef: ViewContainerRef, // needed for modal service
    private commonArrayService: CommonArrayService,
    private activatedRoute: ActivatedRoute,
  ) {
    const isSub = this.activatedRoute.snapshot.queryParams['isSubscriber'];
    this.subscriberOrNot = isSub === 'true';
    if (this.subscriberOrNot) {
      this.selectedUserStatus = 'subscribedUser';
    }
  }

  ngOnInit(): void {
    this.allUserStatus = this.commonArrayService.userStatus;
    this.searchUser.pipe(debounceTime(1000)).subscribe((value) => {
      this.search = value;

      this.getAllUsers();
    });

    this.getAllUsers();
  }

  exportFile(type: string): void {
    const token = localStorage.getItem('token');
    let url = `${this.apiUrl}/api/users/export/${type}?token=${token}`;

    // Only add filter query for specific user status
    switch (this.selectedUserStatus) {
      case 'subscribedUser':
        url += `&isSubscriber=true`;
        break;
      case 'nonSubscribedUser':
        url += `&isSubscriber=false`;
        break;
      case 'all':
      default:
        // No query parameter added - gets all data
        break;
    }

    window.open(url, '_blank');
  }

  onChangeDateRange(date: any) {
    this.startDate = date[0];
    this.endDate = date[1];
    this.getAllUsers();
  }

  /* Open subscription modal using NzModalService */
  openSubscriptionModal(data: any): void {
    const modal = this.modal.create({
      nzTitle: 'User Subscription Details',
      nzContent: SubscriptionModalComponent,
      nzViewContainerRef: this.viewContainerRef,
      nzClosable: true, // cross button enabled
      nzMaskClosable: true,
      nzFooter: null, // no footer buttons
      nzComponentParams: {
        selectedUser: data,
      },
    });

    modal.afterClose.subscribe(() => {});
  }

  /* Pagination / Query params */
  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex } = params;
    this.pageSize = pageSize;
    this.pageIndex = pageIndex;
    this.skipIndex = pageSize * (pageIndex - 1);
    this.getAllUsers(this.skipIndex);
  }

  getAllUsers(skip = 0, sortBy?: any): void {
    const params: any = { skip: this.skipIndex, limit: this.pageSize };

    if (this.search) params.search = this.search;
    if (sortBy) params.sortBy = JSON.stringify(sortBy);
    if (this.startDate && this.endDate) {
      params.startDate = this.startDate;
      params.endDate = this.endDate;
    }

    if (this.selectedUserStatus === 'subscribedUser') {
      this.route.navigate([], { queryParams: { isSubscriber: true } });

      params.subscribedUser = true;
    } else {
      delete params.subscribedUser;
      this.selectedUserStatus = '';
      // Clear the query parameter when filter is cleared
      this.route.navigate([], {});
      // params.isPaid = false;
    }
    if (this.selectedUserStatus === 'loginUser') {
      params.loginUser = true;
    } else {
      delete params.loginUser;
    }
    this.loading = true;
    this.httpRequestService.request('get', 'users', params).subscribe(
      (res) => {
        this.loading = false;
        this.allUsers = res.data;
        this.totalDataCount = res.totalCount;
      },
      () => {
        this.loading = false;
      },
    );
  }

  updateStatus(id: string, status: boolean): void {
    this.httpRequestService
      .request('put', `users/active-inactive/${id}`, { status: !status })
      .subscribe(() => {
        this.notificationService.success('', 'Status Updated Successfully');
        this.getAllUsers();
      });
  }

  openUserDetails(item: any) {
    this.route.navigate(['/', 'main', 'user', 'detail', item._id]);
  }

  changeGridView() {
    this.listView = false;
    this.active = true;
    this.deActive = false;
  }

  changeListView() {
    this.listView = true;
    this.active = false;
    this.deActive = true;
  }

  searchUsers(event: any): void {
    this.searchUser.next(event);
  }
}
